import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { logoutUser } from '../actions/loginActions'
import { setMessageModal, setConfirmModal } from '../actions/generalActions'
import { setFunctionBarType } from '../actions/layoutActions'
import { closeReceiptAndLogOut } from '../actions/receiptActions'
import { getTranslation } from '../actions/dataActions'
import * as general from '../constants/General'
import * as resource from '../constants/Resources'
import PropTypes from 'prop-types'

class Logout extends Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap() {
    if (this.props.receiptnumber === undefined || !this.props.receiptnumber) {
      this.props.setFunctionBarType(general.FUNCTIONBAR_NONE);
      this.props.logoutUser();
    } else if (this.props.objectitemid) {
      this.props.closeReceiptAndLogOut();
    } else {
      this.props.setMessageModal(true, this.props.getTranslation(resource.RECEIPT_IS_OPEN));
    }
  }

  render() {
    var divStyle = this.props.tempRights>0? {
      backgroundColor: 'darkorange'
    } :null;

    return (
      <button className="titlebar-logout" onClick={this.handleTouchTap} style={divStyle}>
        <i className="large sign out icon" />
        <Ink />
      </button>)
  }
}

Logout.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  loggedin: PropTypes.object,
  posid: PropTypes.number,
  receiptnumber: PropTypes.number,
  setMessageModal: PropTypes.func.isRequired,
  setFunctionBarType: PropTypes.func,
  tempRights : PropTypes.number
}
function mapStateToProps(state) {
  return {
    loggedin: state.loginState.loggedin,
    posid: state.generalState.posId,
    tempRights: state.generalState.tempRights,
    receiptnumber: state.receiptState.receipt.receiptnumber,
    objectitemid: state.receiptState.receipt.objectitemid
  }
}

export default connect(mapStateToProps, { 
  logoutUser,
  setMessageModal,
  setFunctionBarType,
  closeReceiptAndLogOut,
  setConfirmModal,
  getTranslation
})(Logout)



// WEBPACK FOOTER //
// src/components/Logout.jsx